export const primaryBg = "#222e28";
export const secondaryBg = "#377B5E";
export const primaryTxt = "#F5F5F5";
export const secondaryTxt = "#D8DCE9";
export const buttonBg = "#031F07";
